import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import BodyRebalanceGsrMetric from './body-rebalance-gsr'
import BodyRebalanceHrvMetric from './body-rebalance-hrv'

const BodyRebalanceList = (props) => (
    <Segment>
        <Header as='h2'>
            4. HOW YOUR BODY REBALANCES AFTER YOUR EMOTIONS
        </Header>
        <p>
            Your Autonomic Nervous System has two components, the Sympathetic Nervous System (Fight or Flight response) 
            and the Parasympathetic Nervous System (Rest and Digest response). Body Rebalance is a set of markers that 
            depict your body’s ability to enter Rest and Digest after Fight or Flight. Studies have shown that your 
            Body Rebalance can be impacted by your levels of anxiety and rumination. The Feel Program supports your 
            body’s ability to rebalance by helping: a) manage and diminish levels of anxiety through gaining awareness 
            of your environmental triggers, coping skills and self-care, b) minimize rumination through cognitive 
            restructuring techniques and behavior change.            
        </p>
        <p>
            Tracking your body’s rebalance will help you see your progress in managing your anxiety and rumination.
        </p>
        <p>
            Below, some emotional events you experienced during the previous week have been chosen, and a pair of charts 
            shows how your Heart Rate (HR) and your Electrodermal Activity (EDA) changed in the first five minutes after 
            each emotional event, while your body was trying to rebalance.
        </p>
        <p>
            EDA responses are tiny changes in the sweat level of your skin, which can be attributed to intense emotional moments, 
            but also other factors, such as movement, noise, ambient conditions, etc. While an individual’s EDA response may vary, 
            you should typically expect fewer EDA responses the calmer you are. Similarly, a decreased HR may indicate that you 
            were able to reach a more relaxed state.
        </p>
        {props.bodyRebalanceMetrics.map((metric) => {
            if (metric["image_name"].includes("gsr_body_rebalance")) {
                return (
                    <BodyRebalanceGsrMetric
                        key={metric["image_name"]}
                        body_rebalance_gsr_metric={metric["encoded_image"]}
                    />
                )
            }
            else if (metric["image_name"].includes("hrv_body_rebalance")) {
                return (
                    <BodyRebalanceHrvMetric
                        key={metric["image_name"]}
                        body_rebalance_hrv_metric={metric["encoded_image"]}
                    />
                )
            }
            else{
                return(
                    <React.Fragment></React.Fragment>
                )
            }
        })}
    </Segment>
)

export default BodyRebalanceList



// WEBPACK FOOTER //
// ./src/components/participant-feel-data-reports/metrics/body-rebalance-list.js